import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, OnDestroy, OnInit } from '@angular/core';
var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var MotorDashboardComponent = /** @class */ (function () {
    function MotorDashboardComponent(motorService) {
        this.motorService = motorService;
        this.devices = [];
        this.readings = [];
        this.graphReadings = [];
        this.reportReadings = [];
        this.selectedDevice = 'M001J26';
        this.detailReading = null;
        this.loading = false;
        this.reportLoading = false;
        this.apiOnline = true;
        this.errorMessage = '';
        this.showDetails = false;
        this.showHistory = false;
        this.lastUpdated = new Date();
        this.selectedTrend = 'temperature';
        this.graphRange = 'today';
        this.graphFrom = '';
        this.graphTo = '';
        this.reportRange = 'today';
        this.reportFrom = '';
        this.reportTo = '';
        this.chart = null;
        this.hover = null;
        this.analytics = [];
        // SVG chart geometry (viewBox units)
        this.W = 760;
        this.H = 420;
        this.PAD = { l: 54, r: 20, t: 14, b: 38 };
        this.chartXs = [];
        this.chartScale = { min: 0, max: 1 };
        this.graphRanges = [
            { value: 'today', label: 'Today' }, { value: 'yesterday', label: 'Yesterday' },
            { value: 'week', label: '7 days' }, { value: 'month', label: '30 days' },
            { value: 'custom', label: 'Custom' }
        ];
        this.reportRanges = this.graphRanges;
        this.trendOptions = [
            { value: 'temperature', label: 'Temperature', unit: '°C', keys: ['Temperature_Sensor_1', 'Temperature_Sensor_2'], names: ['Temperature 1', 'Temperature 2'], colors: ['#e5484d', '#f59f00'] },
            {
                value: 'vibration', label: 'Vibration', unit: 'mm/s',
                keys: ['Vibration_Velocity_X_1', 'Vibration_Velocity_y_1', 'Vibration_Velocity_Z_1', 'Vibration_Velocity_X_2', 'Vibration_Velocity_y_2', 'Vibration_Velocity_Z_2'],
                names: ['S1 X', 'S1 Y', 'S1 Z', 'S2 X', 'S2 Y', 'S2 Z'],
                colors: ['#2563eb', '#0ea5e9', '#06b6d4', '#7c3aed', '#a855f7', '#d946ef']
            },
            { value: 'current', label: 'Current', unit: 'A', keys: ['Current_R', 'Current_Y', 'Current_B'], names: ['R phase', 'Y phase', 'B phase'], colors: ['#e5484d', '#f59f00', '#2563eb'] },
            { value: 'voltage', label: 'Voltage', unit: 'V', keys: ['Voltage_R', 'Voltage_Y', 'Voltage_B'], names: ['R phase', 'Y phase', 'B phase'], colors: ['#e5484d', '#f59f00', '#2563eb'] }
        ];
        this.analyticsDefs = [
            { label: 'Vib. 1 X', key: 'Vibration_Velocity_X_1', unit: '' },
            { label: 'Vib. 1 Y', key: 'Vibration_Velocity_y_1', unit: '' },
            { label: 'Vib. 1 Z', key: 'Vibration_Velocity_Z_1', unit: '' },
            { label: 'Vib. 2 X', key: 'Vibration_Velocity_X_2', unit: '' },
            { label: 'Vib. 2 Y', key: 'Vibration_Velocity_y_2', unit: '' },
            { label: 'Vib. 2 Z', key: 'Vibration_Velocity_Z_2', unit: '' },
            { label: 'Temperature 1', key: 'Temperature_Sensor_1', unit: '°C' },
            { label: 'Temperature 2', key: 'Temperature_Sensor_2', unit: '°C' },
            { label: 'Active power', key: 'Active_Power', unit: '' },
            { label: 'Power factor', key: 'Power_Factor', unit: '' }
        ];
        this.alerts = [];
        this.thresholds = {};
        this.showThresholds = false;
        this.thresholdGroups = [
            { title: 'Temperature', items: [
                    { key: 'Temperature_Sensor_1', label: 'Temperature 1', unit: '°C' },
                    { key: 'Temperature_Sensor_2', label: 'Temperature 2', unit: '°C' }
                ] },
            { title: 'Vibration', items: [
                    { key: 'Vibration_Velocity_X_1', label: 'Vibration 1 X', unit: 'mm/s' },
                    { key: 'Vibration_Velocity_y_1', label: 'Vibration 1 Y', unit: 'mm/s' },
                    { key: 'Vibration_Velocity_Z_1', label: 'Vibration 1 Z', unit: 'mm/s' },
                    { key: 'Vibration_Velocity_X_2', label: 'Vibration 2 X', unit: 'mm/s' },
                    { key: 'Vibration_Velocity_y_2', label: 'Vibration 2 Y', unit: 'mm/s' },
                    { key: 'Vibration_Velocity_Z_2', label: 'Vibration 2 Z', unit: 'mm/s' }
                ] },
            { title: 'Current', items: [
                    { key: 'Current_R', label: 'Current R', unit: 'A' },
                    { key: 'Current_Y', label: 'Current Y', unit: 'A' },
                    { key: 'Current_B', label: 'Current B', unit: 'A' }
                ] },
            { title: 'Voltage', items: [
                    { key: 'Voltage_R', label: 'Voltage R', unit: 'V' },
                    { key: 'Voltage_Y', label: 'Voltage Y', unit: 'V' },
                    { key: 'Voltage_B', label: 'Voltage B', unit: 'V' }
                ] },
            { title: 'Power', items: [
                    { key: 'Frequency', label: 'Frequency', unit: 'Hz' },
                    { key: 'Power_Factor', label: 'Power factor', unit: '' },
                    { key: 'Active_Power', label: 'Active power', unit: '' }
                ] }
        ];
        this.thresholdParams = this.thresholdGroups.reduce(function (a, g) { return a.concat(g.items); }, []);
    }
    MotorDashboardComponent.prototype.paramLabel = function (key) {
        var p = this.thresholdParams.find(function (x) { return x.key === key; });
        return p ? p.label + (p.unit ? ' (' + p.unit + ')' : '') : key;
    };
    /** One separate object per parameter. This is what fixes the "all toggle together" bug. */
    MotorDashboardComponent.prototype.blankThresholds = function () {
        var m = {};
        this.thresholdParams.forEach(function (p) { return m[p.key] = { warn_low: null, warn_high: null, crit_low: null, crit_high: null, enabled: 1 }; });
        return m;
    };
    MotorDashboardComponent.prototype.closeThresholds = function () { this.showThresholds = false; this.loadThresholds(); }; // discards unsaved edits
    Object.defineProperty(MotorDashboardComponent.prototype, "openAlerts", {
        get: function () { return this.alerts.filter(function (a) { return a.status === 'open'; }); },
        enumerable: true,
        configurable: true
    });
    /* ------------------------------ lifecycle ------------------------------ */
    MotorDashboardComponent.prototype.ngOnInit = function () {
        this.thresholds = this.blankThresholds();
        this.loadDevices();
        this.loadReadings();
        this.setGraphRange('today');
        this.loadThresholds();
        this.loadAlerts();
    };
    MotorDashboardComponent.prototype.ngAfterViewInit = function () {
        // Move the modal host to <body> so ancestor transforms/overflow/z-index of the app shell can't shift it.
        if (this.overlayHost) {
            document.body.appendChild(this.overlayHost.nativeElement);
        }
    };
    MotorDashboardComponent.prototype.ngOnDestroy = function () {
        clearInterval(this.timer);
        var el = this.overlayHost && this.overlayHost.nativeElement;
        if (el && el.parentNode) {
            el.parentNode.removeChild(el);
        }
    };
    MotorDashboardComponent.prototype.onEscape = function () { this.closeDetails(); this.closeHistory(); this.closeThresholds(); };
    Object.defineProperty(MotorDashboardComponent.prototype, "latest", {
        /* ------------------------------- getters ------------------------------- */
        get: function () {
            var seen = {};
            var result = [];
            this.readings.forEach(function (r) {
                if (r && r.Deviceid && !seen[r.Deviceid]) {
                    seen[r.Deviceid] = true;
                    result.push(r);
                }
            });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MotorDashboardComponent.prototype, "latestReading", {
        // readings are sorted newest-first, so the first one is always the latest reading
        get: function () { return this.readings[0] || null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MotorDashboardComponent.prototype, "averageTemperature", {
        get: function () { return this.averageLatest('Temperature_Sensor_1'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MotorDashboardComponent.prototype, "averageVibration", {
        get: function () { return this.averageLatest('Vibration_Velocity_X_1'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MotorDashboardComponent.prototype, "activeTrend", {
        get: function () {
            var _this = this;
            return this.trendOptions.find(function (x) { return x.value === _this.selectedTrend; }) || this.trendOptions[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MotorDashboardComponent.prototype, "selectedDeviceLabel", {
        get: function () { return this.selectedDevice === 'all' ? 'All motors' : this.selectedDevice; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MotorDashboardComponent.prototype, "activeRangeLabel", {
        get: function () {
            var _this = this;
            var r = this.graphRanges.find(function (x) { return x.value === _this.graphRange; });
            return r ? r.label : '';
        },
        enumerable: true,
        configurable: true
    });
    MotorDashboardComponent.prototype.deviceName = function (d) { return d.Deviceid || d.deviceId || d.device_id; };
    /* ------------------------------ data loading ---------------------------- */
    MotorDashboardComponent.prototype.reloadAll = function () {
        this.loadDevices();
        this.loadReadings();
        if (this.graphRange === 'custom') {
            this.loadGraphReadings();
        }
        else {
            this.setGraphRange(this.graphRange);
        }
        if (this.showHistory) {
            this.loadReportReadings();
        }
    };
    MotorDashboardComponent.prototype.loadDevices = function () {
        var _this = this;
        this.motorService.getDevices().subscribe(function (response) {
            var rows = Array.isArray(response) ? response : (response.data || response.devices || response.rows || []);
            _this.devices = rows.map(function (item) { return typeof item === 'string' ? { Deviceid: item } : item; });
        }, function (error) { return console.error('Motor devices API failed:', error); });
    };
    MotorDashboardComponent.prototype.loadReadings = function () {
        var _this = this;
        this.loading = true;
        var filters = { limit: 1000 };
        if (this.selectedDevice !== 'all') {
            filters.deviceId = this.selectedDevice;
        }
        this.motorService.getReadings(filters).subscribe(function (response) {
            var rows = Array.isArray(response) ? response : (response.data || response.readings || response.rows || []);
            _this.readings = _this.sortDesc(rows);
            _this.lastUpdated = new Date();
            _this.apiOnline = true;
            _this.errorMessage = '';
            _this.loading = false;
        }, function (error) {
            _this.loading = false;
            _this.apiOnline = false;
            _this.errorMessage = 'Could not load motor readings. Check that the API is running, then press refresh.';
            console.error('Motor readings API failed:', error);
        });
    };
    MotorDashboardComponent.prototype.selectDevice = function (deviceId) {
        this.selectedDevice = deviceId;
        this.loadReadings();
        this.loadGraphReadings();
        this.loadThresholds();
        this.loadAlerts();
        if (this.showHistory) {
            this.loadReportReadings();
        }
    };
    MotorDashboardComponent.prototype.changeTrend = function (value) { this.selectedTrend = value; this.buildChart(); };
    MotorDashboardComponent.prototype.setGraphRange = function (range) {
        this.graphRange = range;
        if (range === 'custom') {
            return;
        }
        var dates = this.rangeDates(range);
        this.graphFrom = this.toLocalInput(dates.from);
        this.graphTo = this.toLocalInput(dates.to);
        this.loadGraphReadings();
    };
    MotorDashboardComponent.prototype.applyGraphRange = function () {
        if (!this.graphFrom || !this.graphTo || new Date(this.graphFrom) > new Date(this.graphTo)) {
            this.errorMessage = 'Choose a valid graph start and end date.';
            return;
        }
        this.errorMessage = '';
        this.loadGraphReadings();
    };
    MotorDashboardComponent.prototype.loadGraphReadings = function () {
        var _this = this;
        var filters = { limit: 5000 };
        if (this.selectedDevice !== 'all') {
            filters.deviceId = this.selectedDevice;
        }
        if (this.graphFrom) {
            filters.from = this.graphFrom.replace('T', ' ') + ':00';
        }
        if (this.graphTo) {
            filters.to = this.graphTo.replace('T', ' ') + ':59';
        }
        this.motorService.getReadings(filters).subscribe(function (response) {
            var rows = Array.isArray(response) ? response : (response.data || response.readings || response.rows || []);
            _this.graphReadings = rows.filter(function (r) { return r && r.reading_time; })
                .sort(function (a, b) { return _this.ts(a.reading_time) - _this.ts(b.reading_time); });
            _this.buildChart();
            _this.buildAnalytics();
        }, function (error) {
            console.error('Motor graph API failed:', error);
            _this.graphReadings = [];
            _this.chart = null;
            _this.buildAnalytics();
        });
    };
    /* ------------------------------ modals ---------------------------------- */
    MotorDashboardComponent.prototype.openDetails = function (reading) { this.detailReading = reading; this.showDetails = true; };
    MotorDashboardComponent.prototype.closeDetails = function () { this.showDetails = false; };
    MotorDashboardComponent.prototype.openHistory = function () {
        this.showHistory = true;
        if (!this.reportFrom || !this.reportTo) {
            this.setReportRange('today');
        }
        else {
            this.loadReportReadings();
        }
    };
    MotorDashboardComponent.prototype.closeHistory = function () { this.showHistory = false; };
    MotorDashboardComponent.prototype.setReportRange = function (range) {
        this.reportRange = range;
        if (range === 'custom') {
            return;
        }
        var dates = this.rangeDates(range);
        this.reportFrom = this.toLocalInput(dates.from);
        this.reportTo = this.toLocalInput(dates.to);
        this.loadReportReadings();
    };
    MotorDashboardComponent.prototype.applyReportRange = function () {
        if (!this.reportFrom || !this.reportTo || new Date(this.reportFrom) > new Date(this.reportTo)) {
            this.errorMessage = 'Choose a valid report start and end date.';
            return;
        }
        this.errorMessage = '';
        this.loadReportReadings();
    };
    MotorDashboardComponent.prototype.loadReportReadings = function () {
        var _this = this;
        this.reportLoading = true;
        var filters = { limit: 5000 };
        if (this.selectedDevice !== 'all') {
            filters.deviceId = this.selectedDevice;
        }
        if (this.reportFrom) {
            filters.from = this.reportFrom.replace('T', ' ') + ':00';
        }
        if (this.reportTo) {
            filters.to = this.reportTo.replace('T', ' ') + ':59';
        }
        this.motorService.getReadings(filters).subscribe(function (response) {
            var rows = Array.isArray(response) ? response : (response.data || response.readings || response.rows || []);
            _this.reportReadings = _this.sortDesc(rows);
            _this.reportLoading = false;
        }, function (error) { _this.reportLoading = false; console.error('Motor report API failed:', error); });
    };
    /* ------------------------------ formatting ------------------------------ */
    MotorDashboardComponent.prototype.value = function (reading, key) {
        var raw = reading && reading[key];
        var n = Number(raw);
        return raw !== null && raw !== undefined && raw !== '' && isFinite(n) ? n : null;
    };
    MotorDashboardComponent.prototype.format = function (value, decimals) {
        if (decimals === void 0) { decimals = 2; }
        var n = Number(value);
        return value === null || value === undefined || value === '' || !isFinite(n) ? '—' : n.toFixed(decimals);
    };
    /**
     * reading_time is a wall-clock time sent by the device (MySQL DATETIME, no timezone).
     * We must show it exactly as stored. If the API serialises it as an ISO string
     * ("2026-10-13T14:38:10.000Z") a normal `new Date()` / date pipe would shift it by the
     * browser's UTC offset (+05:30 in India). So we read the numbers out of the string and
     * ignore any "Z" / offset suffix.
     */
    MotorDashboardComponent.prototype.parseReadingDate = function (value) {
        if (value instanceof Date) {
            return value;
        }
        if (typeof value === 'string') {
            var m = value.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/);
            if (m) {
                return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
            }
        }
        return new Date(value);
    };
    MotorDashboardComponent.prototype.ts = function (value) { return this.parseReadingDate(value).getTime(); };
    MotorDashboardComponent.prototype.sortDesc = function (rows) {
        var _this = this;
        return rows.slice().sort(function (a, b) { return _this.ts(b.reading_time) - _this.ts(a.reading_time); });
    };
    MotorDashboardComponent.prototype.p2 = function (n) { return n < 10 ? '0' + n : String(n); };
    /** "13 Oct 2026, 14:38:10" — same value that is stored in the database. */
    MotorDashboardComponent.prototype.dateLabel = function (value, withSeconds) {
        if (withSeconds === void 0) { withSeconds = true; }
        if (!value) {
            return '—';
        }
        var d = this.parseReadingDate(typeof value === 'string' ? value.replace('T', ' ') : value);
        if (isNaN(d.getTime())) {
            return String(value);
        }
        return this.p2(d.getDate()) + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear() + ', ' +
            this.p2(d.getHours()) + ':' + this.p2(d.getMinutes()) + (withSeconds ? ':' + this.p2(d.getSeconds()) : '');
    };
    MotorDashboardComponent.prototype.timeAgo = function (value) {
        var diff = Date.now() - this.ts(value);
        if (isNaN(diff)) {
            return '';
        }
        var min = Math.floor(diff / 60000);
        if (min < 1) {
            return 'just now';
        }
        if (min < 60) {
            return min + ' min ago';
        }
        var h = Math.floor(min / 60);
        if (h < 24) {
            return h + ' h ago';
        }
        return Math.floor(h / 24) + ' d ago';
    };
    MotorDashboardComponent.prototype.isOnline = function (reading) {
        var age = Date.now() - this.ts(reading.reading_time);
        return !isNaN(age) && age <= 30 * 60 * 1000;
    };
    /* ------------------------------- chart ---------------------------------- */
    MotorDashboardComponent.prototype.buildChart = function () {
        var _this = this;
        this.hover = null;
        var rows = this.graphReadings;
        var trend = this.activeTrend;
        var keys = trend.keys;
        var min = Infinity;
        var max = -Infinity;
        rows.forEach(function (r) { return keys.forEach(function (k) {
            var v = _this.value(r, k);
            if (v !== null) {
                if (v < min) {
                    min = v;
                }
                if (v > max) {
                    max = v;
                }
            }
        }); });
        if (!isFinite(min)) {
            this.chart = null;
            this.chartXs = [];
            return;
        }
        var pad = max === min ? Math.max(Math.abs(max) * 0.05, 1) : (max - min) * 0.12;
        min -= pad;
        max += pad;
        this.chartScale = { min: min, max: max };
        var P = this.PAD;
        var plot = { l: P.l, r: this.W - P.r, t: P.t, b: this.H - P.b };
        var times = rows.map(function (r) { return _this.ts(r.reading_time); });
        var t0 = times[0];
        var t1 = times[times.length - 1];
        var xOf = function (t) { return t1 === t0 ? (plot.l + plot.r) / 2 : plot.l + (t - t0) / (t1 - t0) * (plot.r - plot.l); };
        var yOf = function (v) { return plot.t + (1 - (v - min) / (max - min)) * (plot.b - plot.t); };
        this.chartXs = times.map(xOf);
        var showDots = rows.length <= 60;
        var series = keys.map(function (key, i) {
            var pts = [];
            rows.forEach(function (r, idx) { var v = _this.value(r, key); if (v !== null) {
                pts.push({ x: _this.chartXs[idx], y: yOf(v) });
            } });
            var line = _this.smoothPath(pts);
            var area = pts.length > 1 ? line + 'L' + pts[pts.length - 1].x.toFixed(1) + ',' + plot.b + 'L' + pts[0].x.toFixed(1) + ',' + plot.b + 'Z' : '';
            return { name: trend.names[i], color: trend.colors[i], line: line, area: area, dots: showDots ? pts : [] };
        });
        var step = (max - min) / 4;
        var dec = step >= 10 ? 0 : step >= 1 ? 1 : 2;
        var yTicks = [0, 1, 2, 3, 4].map(function (i) { var v = min + step * i; return { y: yOf(v), label: v.toFixed(dec) }; });
        var span = t1 - t0;
        var xTicks = [];
        if (span === 0) {
            xTicks.push({ x: xOf(t0), label: this.dateLabel(rows[0].reading_time, false), anchor: 'middle' });
        }
        else {
            for (var i = 0; i < 5; i++) {
                var t = t0 + span * i / 4;
                var d = new Date(t);
                var label = span > 36 * 3600000
                    ? d.getDate() + ' ' + MONTHS[d.getMonth()]
                    : (span > 24 * 3600000 ? d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' : '') + this.p2(d.getHours()) + ':' + this.p2(d.getMinutes());
                xTicks.push({ x: xOf(t), label: label, anchor: i === 0 ? 'start' : (i === 4 ? 'end' : 'middle') });
            }
        }
        this.chart = { plot: plot, series: series, yTicks: yTicks, xTicks: xTicks };
    };
    /** Monotone cubic interpolation: smooth curves that never overshoot the real data. */
    MotorDashboardComponent.prototype.smoothPath = function (p) {
        var n = p.length;
        var f = function (v) { return v.toFixed(1); };
        if (n === 0) {
            return '';
        }
        if (n === 1) {
            return 'M' + f(p[0].x) + ',' + f(p[0].y);
        }
        if (n === 2) {
            return 'M' + f(p[0].x) + ',' + f(p[0].y) + 'L' + f(p[1].x) + ',' + f(p[1].y);
        }
        var dx = [];
        var m = [];
        var t = [];
        for (var i = 0; i < n - 1; i++) {
            dx[i] = p[i + 1].x - p[i].x;
            m[i] = dx[i] === 0 ? 0 : (p[i + 1].y - p[i].y) / dx[i];
        }
        t[0] = m[0];
        t[n - 1] = m[n - 2];
        for (var i = 1; i < n - 1; i++) {
            t[i] = m[i - 1] * m[i] <= 0 ? 0 : (m[i - 1] + m[i]) / 2;
        }
        for (var i = 0; i < n - 1; i++) {
            if (m[i] === 0) {
                t[i] = 0;
                t[i + 1] = 0;
                continue;
            }
            var a = t[i] / m[i];
            var b = t[i + 1] / m[i];
            var s = a * a + b * b;
            if (s > 9) {
                var k = 3 / Math.sqrt(s);
                t[i] = k * a * m[i];
                t[i + 1] = k * b * m[i];
            }
        }
        var d = 'M' + f(p[0].x) + ',' + f(p[0].y);
        for (var i = 0; i < n - 1; i++) {
            var h = dx[i] / 3;
            d += 'C' + f(p[i].x + h) + ',' + f(p[i].y + t[i] * h) + ' ' + f(p[i + 1].x - h) + ',' + f(p[i + 1].y - t[i + 1] * h) + ' ' + f(p[i + 1].x) + ',' + f(p[i + 1].y);
        }
        return d;
    };
    MotorDashboardComponent.prototype.onChartMove = function (ev, svg) {
        var _this = this;
        if (!this.chart || !this.chartXs.length) {
            return;
        }
        var rect = svg.getBoundingClientRect();
        var px = (ev.clientX - rect.left) / rect.width * this.W;
        var best = 0;
        var bestDist = Infinity;
        this.chartXs.forEach(function (x, i) { var d = Math.abs(x - px); if (d < bestDist) {
            bestDist = d;
            best = i;
        } });
        var r = this.graphReadings[best];
        var trend = this.activeTrend;
        var plot = this.chart.plot;
        var sc = this.chartScale;
        var items = [];
        trend.keys.forEach(function (k, i) {
            var v = _this.value(r, k);
            if (v !== null) {
                items.push({
                    name: trend.names[i], color: trend.colors[i], value: v.toFixed(2) + ' ' + trend.unit,
                    y: plot.t + (1 - (v - sc.min) / (sc.max - sc.min)) * (plot.b - plot.t)
                });
            }
        });
        var x = this.chartXs[best];
        this.hover = { x: x, xPct: x / this.W * 100, time: this.dateLabel(r.reading_time), flip: x / this.W > 0.6, items: items };
    };
    /* ------------------------------ analytics ------------------------------- */
    MotorDashboardComponent.prototype.buildAnalytics = function () {
        var _this = this;
        this.analytics = this.analyticsDefs.map(function (def) {
            var vals = _this.graphReadings.map(function (r) { return _this.value(r, def.key); }).filter(function (v) { return v !== null; });
            if (!vals.length) {
                return { label: def.label, unit: def.unit, min: '—', max: '—', avg: '—' };
            }
            var min = Math.min.apply(null, vals);
            var max = Math.max.apply(null, vals);
            var avg = vals.reduce(function (a, b) { return a + b; }, 0) / vals.length;
            return { label: def.label, unit: def.unit, min: _this.format(min), max: _this.format(max), avg: _this.format(avg) };
        });
    };
    /* ------------------------------- export --------------------------------- */
    MotorDashboardComponent.prototype.exportHistoryCsv = function () {
        var columns = [
            ['Device ID', 'Deviceid'], ['Reading Time', 'reading_time'],
            ['Vibration 1 X', 'Vibration_Velocity_X_1'], ['Vibration 1 Y', 'Vibration_Velocity_y_1'], ['Vibration 1 Z', 'Vibration_Velocity_Z_1'],
            ['Vibration 2 X', 'Vibration_Velocity_X_2'], ['Vibration 2 Y', 'Vibration_Velocity_y_2'], ['Vibration 2 Z', 'Vibration_Velocity_Z_2'], ['Temperature Sensor 1', 'Temperature_Sensor_1'], ['Temperature Sensor 2', 'Temperature_Sensor_2'],
            ['Voltage R', 'Voltage_R'], ['Voltage Y', 'Voltage_Y'], ['Voltage B', 'Voltage_B'],
            ['Current R', 'Current_R'], ['Current Y', 'Current_Y'], ['Current B', 'Current_B'],
            ['Frequency', 'Frequency'], ['Active Power', 'Active_Power'], ['Power Factor', 'Power_Factor'],
            ['Voltage THD R', 'Voltage_THD_R'], ['Voltage THD Y', 'Voltage_THD_Y'], ['Voltage THD B', 'Voltage_THD_B'],
            ['Current THD R', 'Current_THD_R'], ['Current THD Y', 'Current_THD_Y'], ['Current THD B', 'Current_THD_B'],
            ['Version', 'Version'], ['Network', 'Network']
        ];
        var esc = function (value) { return '"' + String(value === null || value === undefined ? '' : value).replace(/"/g, '""') + '"'; };
        var cell = function (r, key) { return key === 'reading_time' ? String(r[key]).replace('T', ' ').slice(0, 19) : r[key]; };
        var lines = [columns.map(function (c) { return esc(c[0]); }).join(',')];
        this.reportReadings.forEach(function (r) { return lines.push(columns.map(function (c) { return esc(cell(r, c[1])); }).join(',')); });
        var blob = new Blob(['\ufeff' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'motor-readings-' + (this.selectedDevice === 'all' ? 'all' : this.selectedDevice) + '-' + this.toLocalInput(new Date()).slice(0, 10) + '.csv';
        a.click();
        URL.revokeObjectURL(url);
    };
    /* ------------------------------- helpers -------------------------------- */
    MotorDashboardComponent.prototype.averageLatest = function (key) {
        var _this = this;
        var rows = this.latest.filter(function (r) { return _this.value(r, key) !== null; });
        return rows.length ? rows.reduce(function (sum, r) { return sum + Number(r[key]); }, 0) / rows.length : null;
    };
    MotorDashboardComponent.prototype.rangeDates = function (range) {
        var now = new Date();
        var from = new Date(now);
        var to = new Date(now);
        if (range === 'today') {
            from.setHours(0, 0, 0, 0);
            to.setHours(23, 59, 59, 0);
        }
        else if (range === 'yesterday') {
            from.setDate(from.getDate() - 1);
            from.setHours(0, 0, 0, 0);
            to.setTime(from.getTime());
            to.setHours(23, 59, 59, 0);
        }
        else if (range === 'week') {
            from.setDate(from.getDate() - 6);
            from.setHours(0, 0, 0, 0);
            to.setHours(23, 59, 59, 0);
        }
        else if (range === 'month') {
            from.setDate(from.getDate() - 29);
            from.setHours(0, 0, 0, 0);
            to.setHours(23, 59, 59, 0);
        }
        return { from: from, to: to };
    };
    MotorDashboardComponent.prototype.toLocalInput = function (date) {
        return date.getFullYear() + '-' + this.p2(date.getMonth() + 1) + '-' + this.p2(date.getDate()) + 'T' + this.p2(date.getHours()) + ':' + this.p2(date.getMinutes());
    };
    MotorDashboardComponent.prototype.thresholdDevice = function () { return this.selectedDevice === 'all' ? '*' : this.selectedDevice; };
    MotorDashboardComponent.prototype.loadThresholds = function () {
        var _this = this;
        var dev = this.thresholdDevice();
        this.motorService.getThresholds(dev).subscribe(function (res) {
            var rows = res.data || [];
            var m = _this.blankThresholds();
            rows.filter(function (r) { return r.Deviceid === '*'; }).forEach(function (r) { if (m[r.parameter]) {
                m[r.parameter] = tslib_1.__assign({}, m[r.parameter], r);
            } });
            rows.filter(function (r) { return r.Deviceid === dev; }).forEach(function (r) { if (m[r.parameter]) {
                m[r.parameter] = tslib_1.__assign({}, m[r.parameter], r);
            } });
            _this.thresholds = m;
        }, function (e) { return console.error('Thresholds API failed:', e); });
    };
    MotorDashboardComponent.prototype.loadAlerts = function () {
        var _this = this;
        var f = { limit: 200 };
        if (this.selectedDevice !== 'all') {
            f.deviceId = this.selectedDevice;
        }
        this.motorService.getAlerts(f).subscribe(function (res) { _this.alerts = res.data || []; }, function (e) { return console.error('Alerts API failed:', e); });
    };
    MotorDashboardComponent.prototype.ackAlert = function (a) {
        var _this = this;
        this.motorService.ackAlert(a.id).subscribe(function () { return _this.loadAlerts(); });
    };
    MotorDashboardComponent.prototype.openThresholds = function () { this.showThresholds = true; };
    MotorDashboardComponent.prototype.saveThresholds = function () {
        var _this = this;
        var items = this.thresholdParams.map(function (p) { return (tslib_1.__assign({ parameter: p.key }, _this.thresholds[p.key])); }); // send all rows, so cleared boxes are saved too
        this.motorService.saveThresholds({ Deviceid: this.thresholdDevice(), items: items }).subscribe(function () {
            _this.showThresholds = false;
            _this.loadThresholds();
            _this.loadAlerts();
        }, function () { return _this.errorMessage = 'Could not save thresholds.'; });
    };
    /** CSS class for a value: red if critical, amber if warning */
    MotorDashboardComponent.prototype.level = function (reading, key) {
        var t = this.thresholds[key];
        var v = this.value(reading, key);
        if (!t || v === null || t.enabled === 0) {
            return '';
        }
        if ((t.crit_high != null && v >= t.crit_high) || (t.crit_low != null && v <= t.crit_low)) {
            return 'mm-crit';
        }
        if ((t.warn_high != null && v >= t.warn_high) || (t.warn_low != null && v <= t.warn_low)) {
            return 'mm-warn';
        }
        return '';
    };
    MotorDashboardComponent.prototype.exportAlertsCsv = function () {
        var esc = function (v) { return '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"'; };
        var cols = ['Deviceid', 'reading_time', 'parameter', 'value', 'direction', 'threshold', 'severity', 'status'];
        var lines = [cols.join(',')].concat(this.alerts.map(function (a) { return cols.map(function (c) { return esc(a[c]); }).join(','); }));
        var url = URL.createObjectURL(new Blob(['\ufeff' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' }));
        var el = document.createElement('a');
        el.href = url;
        el.download = 'motor-alerts.csv';
        el.click();
        URL.revokeObjectURL(url);
    };
    return MotorDashboardComponent;
}());
export { MotorDashboardComponent };
